import * as React from "react";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Toast from "../../../helper/Toast";
import EditFinanceProductFormView from "./EditFinanceProductFormView";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import FinanceProduct from "../../../../model/financeProduct/FinanceProduct";
import {editFinanceProduct} from "../../../../store/action/financeProduct/financeProduct";

interface IComponentProps {
	/**
	 * Close modal
	 */
	closeModal: () => void;
	/**
	 * Finance product to edit
	 */
	editedFinanceProduct: FinanceProduct;
}

interface IDispatchProps {
	/**
	 * Update finance product.
	 * @param {FinanceProduct} data
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateFinanceProduct: (data: FinanceProduct, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps

class EditFinanceProductForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<EditFinanceProductFormView onSubmit={this.onSubmit}
										onCancel={this.props.closeModal}
										isSubmitting={this.state.isSubmitting}
										editedFinanceProduct={this.props.editedFinanceProduct}/>
		);
	}

	onSubmit(data: FinanceProduct) {
		this.setState({isSubmitting: true}, () => {
			this.props.updateFinanceProduct(
				data,
				() => {
					this.setState({isSubmitting: false}, () => {
						Toast.success("Finance product updated", "Finance product update");
						this.props.closeModal();
					});
				},
				(error) => {
					this.setState({isSubmitting: false});
					notifyBugsnagAndShowToast(error, "Finance product update")
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>, props: IComponentProps) {
	return {
		updateFinanceProduct: (data: FinanceProduct, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(editFinanceProduct(props.editedFinanceProduct.id, data, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(EditFinanceProductForm);
